import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useSupportService = () => {
  const { language } = useLanguage();
  const t =
    messageTranslations[language]?.support || messageTranslations["de"].support;

  const createSupportTicket = async ({
    sender,
    topic,
    subject,
    description,
  }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/support/create-ticket`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ sender, topic, subject, description }),
        }
      );

      if (!response.ok) {
        throw new Error(t.createError);
      }

      const data = await response.json();
      message.success(t.createSuccess || data.message);
      return data;
    } catch (error) {
      console.error("createSupportTicket:", error.message);
      message.error(error.message || t.createError);
      return null;
    }
  };

  const getAllTickets = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/support/get-tickets`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.loadError);
      }

      const data = await response.json();
      return data.tickets;
    } catch (error) {
      console.error("getAllTickets:", error.message);
      message.error(error.message || t.loadError);
      return null;
    }
  };

  const updateTicket = async (ticketId, updateData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/support/update/${ticketId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify(updateData),
        }
      );

      if (!response.ok) {
        throw new Error(t.updateError);
      }

      const data = await response.json();
      message.success(t.updateSuccess || data.message);
      return data.ticket;
    } catch (error) {
      console.error("updateTicket:", error.message);
      message.error(error.message || t.updateError);
      return null;
    }
  };

  return {
    createSupportTicket,
    getAllTickets,
    updateTicket,
  };
};

export default useSupportService;
